import * as React from 'react';

import { ISiteUserInfo } from '../../../ts/models/ISiteUserInfo';

export type AuthenticationProviderFunction = (user: ISiteUserInfo) => {name: string, isEnabled: boolean};

export const SiteUserAuthenticationProviderContext: React.Context<AuthenticationProviderFunction>
  = React.createContext<AuthenticationProviderFunction>(undefined);
